import type { RootState } from '../store';

export const getAccountPreferences = (state: RootState) => state.accountPreferences;

export const getAccountTimezone = (state: RootState) => state.accountPreferences.timeZone;
